module.exports = __webpack_public_path__ + "img/no_broadcast_list.cd9096a5.svg";